module.exports = __webpack_public_path__ + "static/media/labExhaust.7a1c91f1.png";